import {
  Sparkles,
  Wrench,
  ClipboardCheck,
  Truck,
  Settings,
  Star,
  Users,
  HelpCircle,
  LogIn,
  LogOut,
  MessageSquare,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

const TASK_TYPE_ICONS: Record<string, LucideIcon> = {
  cleaning: Sparkles,
  maintenance: Wrench,
  inspection: ClipboardCheck,
  delivery: Truck,
  admin: Settings,
  administrative: Settings,
  special: Star,
  guest_service: Users,
  guest_request: MessageSquare,
  'check-in': LogIn,
  'check-out': LogOut,
  other: HelpCircle,
}

const TASK_TYPE_ICON_BG: Record<string, string> = {
  cleaning: 'bg-blue-100 dark:bg-blue-950/50',
  maintenance: 'bg-orange-100 dark:bg-orange-950/50',
  inspection: 'bg-primary-soft',
  delivery: 'bg-emerald-100 dark:bg-emerald-950/50',
  admin: 'bg-muted',
  administrative: 'bg-muted',
  special: 'bg-yellow-100 dark:bg-yellow-950/50',
  guest_service: 'bg-pink-100 dark:bg-pink-950/50',
  guest_request: 'bg-pink-100 dark:bg-pink-950/50',
  'check-in': 'bg-green-100 dark:bg-green-950/50',
  'check-out': 'bg-red-100 dark:bg-red-950/50',
  other: 'bg-muted',
}

const SPECIAL_TASK_LABELS: Record<string, string> = {
  'special.meeting': 'Meeting',
  'special.office_work': 'Office Work',
  'special.team_support': 'Team Support',
  'special.shopping': 'Shopping',
  'special.training': 'Training',
  'special.driving': 'Driving',
}

export const getTaskTypeIcon = (type: string): LucideIcon => {
  return TASK_TYPE_ICONS[type] || TASK_TYPE_ICONS.other
}

export const getTaskTypeIconBg = (type: string): string => {
  return TASK_TYPE_ICON_BG[type] || TASK_TYPE_ICON_BG.other
}

const STATUS_BG_MAP: Record<string, string> = {
  open: 'bg-red-100 dark:bg-red-900/40',
  in_progress: 'bg-amber-100 dark:bg-amber-900/40',
  completed: 'bg-green-100 dark:bg-green-900/40',
  cancelled: 'bg-muted dark:bg-gray-900 opacity-60',
  on_hold: 'bg-orange-100 dark:bg-orange-900/40',
}

export function getTaskStatusBg(status: string): string {
  return STATUS_BG_MAP[status] || STATUS_BG_MAP.open
}

export const getSpecialTaskLabel = (subtypeCode?: string): string => {
  if (!subtypeCode) return 'Special Task'
  return SPECIAL_TASK_LABELS[subtypeCode] || subtypeCode.replace('special.', '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
